<template>
    <div class="row">
        <div class="card">
            <div class="card-header">
                <h2>Nova Publicação</h2>
            </div>
            <form-publicacao />
        </div>
    </div>
</template>

<script>
import FormPublicacao from "./form-publicacao";
export default {
name: "nova-publicacao",
    components: { FormPublicacao }
}
</script>
